import { IthacaJwt } from '@dtx-company/ithaca-sdk/src'
import { RootState } from '../../redux/types'
import { useSelector } from 'react-redux'

export function useIsFronteggUser(): boolean {
  return useSelector((state: RootState) => state.appReducer.userReducer.isFronteggUser)
}

export function useIsAuthChecked(): boolean {
  return useSelector((state: RootState) => state.appReducer.userReducer.isAuthChecked)
}

export function useIsImpersonating(): boolean {
  return useSelector(
    (state: RootState) => state.appReducer.userReducer.impersonatedUserData !== null
  )
}

export function useCurrentUserJwt(): IthacaJwt | null {
  const userJwt = useSelector((state: RootState) => state.appReducer.userReducer.currentUserData)
  const impersonatedUserJwt = useSelector(
    (state: RootState) => state.appReducer.userReducer.impersonatedUserData
  )
  return impersonatedUserJwt ?? userJwt
}
